import { render, staticRenderFns } from "./FederationMissingNotice.vue?vue&type=template&id=787bea54"
import script from "./FederationMissingNotice.vue?vue&type=script&lang=js"
export * from "./FederationMissingNotice.vue?vue&type=script&lang=js"
import style0 from "./FederationMissingNotice.vue?vue&type=style&index=0&id=787bea54&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports